export default "__VITE_ASSET__C8Cdad1m__"